<template>
  <span class="invalid-feedback d-block" role="alert">
        <strong><slot></slot></strong>
  </span>
</template>

<script>
export default {
  props: {
    errorMessage: {
      type: String
    }
  }
}
</script>